/* Haarspeldjes & zo – speldjes los knippen uit een productfoto.
   Werkt op witte en gekleurde achtergronden en op kaartjes (kraft) met meerdere speldjes.
   knip(img) -> Array<HTMLCanvasElement> (uitgeknipte stukken, transparant) */
var HZKnip = (function () {
  var LAAG = 480, HOOG = 1600, MAXSTUK = 720;

  function rgbNaarLab(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    var x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047, y = r * 0.2126 + g * 0.7152 + b * 0.0722, z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    function f(t) { return t > 0.008856 ? Math.cbrt(t) : 7.787 * t + 16 / 116; }
    var fx = f(x), fy = f(y), fz = f(z);
    return [116 * fy - 16, 500 * (fx - fy), 200 * (fy - fz)];
  }
  function afstand(L, A, B, i, m) { var dl = L[i] - m[0], da = A[i] - m[1], db = B[i] - m[2]; return Math.sqrt(dl * dl * 0.5 + da * da + db * db); }

  function afstandKaart(mask, w, h) {
    var n = w * h, d = new Float32Array(n), INF = 1e9, a = 1, b = 1.4142;
    for (var i = 0; i < n; i++) d[i] = mask[i] ? INF : 0;
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
      var p = y * w + x; if (!d[p]) continue; var v = d[p];
      if (x > 0) v = Math.min(v, d[p - 1] + a); else v = Math.min(v, 1);
      if (y > 0) { v = Math.min(v, d[p - w] + a); if (x > 0) v = Math.min(v, d[p - w - 1] + b); if (x < w - 1) v = Math.min(v, d[p - w + 1] + b); } else v = Math.min(v, 1);
      d[p] = v;
    }
    for (var y2 = h - 1; y2 >= 0; y2--) for (var x2 = w - 1; x2 >= 0; x2--) {
      var q = y2 * w + x2; if (!d[q]) continue; var u = d[q];
      if (x2 < w - 1) u = Math.min(u, d[q + 1] + a); else u = Math.min(u, 1);
      if (y2 < h - 1) { u = Math.min(u, d[q + w] + a); if (x2 < w - 1) u = Math.min(u, d[q + w + 1] + b); if (x2 > 0) u = Math.min(u, d[q + w - 1] + b); } else u = Math.min(u, 1);
      d[q] = u;
    }
    return d;
  }
  function erodeer(mask, w, h, r) { var d = afstandKaart(mask, w, h), o = new Uint8Array(w * h); for (var i = 0; i < o.length; i++) o[i] = d[i] > r ? 1 : 0; return o; }
  function dilateer(mask, w, h, r) {
    var inv = new Uint8Array(w * h); for (var i = 0; i < inv.length; i++) inv[i] = mask[i] ? 0 : 1;
    var d = afstandKaart(inv, w, h), o = new Uint8Array(w * h); for (var j = 0; j < o.length; j++) o[j] = (mask[j] || d[j] <= r) ? 1 : 0; return o;
  }
  function labels(mask, w, h) {
    var n = w * h, lab = new Int32Array(n), st = new Int32Array(n), info = [null];
    for (var s = 0; s < n; s++) {
      if (!mask[s] || lab[s]) continue;
      var id = info.length, top = 0, x0 = w, y0 = h, x1 = 0, y1 = 0, opp = 0, rand = 0;
      st[top++] = s; lab[s] = id;
      while (top) {
        var p = st[--top], px = p % w, py = (p - px) / w; opp++;
        if (px < x0) x0 = px; if (px > x1) x1 = px; if (py < y0) y0 = py; if (py > y1) y1 = py;
        if (px === 0 || py === 0 || px === w - 1 || py === h - 1) rand++;
        if (px > 0 && mask[p - 1] && !lab[p - 1]) { lab[p - 1] = id; st[top++] = p - 1; }
        if (px < w - 1 && mask[p + 1] && !lab[p + 1]) { lab[p + 1] = id; st[top++] = p + 1; }
        if (py > 0 && mask[p - w] && !lab[p - w]) { lab[p - w] = id; st[top++] = p - w; }
        if (py < h - 1 && mask[p + w] && !lab[p + w]) { lab[p + w] = id; st[top++] = p + w; }
      }
      info.push({ id: id, x0: x0, y0: y0, x1: x1, y1: y1, opp: opp, rand: rand });
    }
    return { lab: lab, info: info };
  }
  function omhulsel(pts) {
    pts.sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; });
    function kruis(o, a, b) { return (a[0] - o[0]) * (b[1] - o[1]) - (a[1] - o[1]) * (b[0] - o[0]); }
    var lo = [], hi = [];
    for (var i = 0; i < pts.length; i++) { while (lo.length >= 2 && kruis(lo[lo.length - 2], lo[lo.length - 1], pts[i]) <= 0) lo.pop(); lo.push(pts[i]); }
    for (var j = pts.length - 1; j >= 0; j--) { while (hi.length >= 2 && kruis(hi[hi.length - 2], hi[hi.length - 1], pts[j]) <= 0) hi.pop(); hi.push(pts[j]); }
    lo.pop(); hi.pop(); return lo.concat(hi);
  }
  function polyOpp(p) { var s = 0; for (var i = 0; i < p.length; i++) { var a = p[i], b = p[(i + 1) % p.length]; s += a[0] * b[1] - b[0] * a[1]; } return Math.abs(s) / 2; }
  function kleinsteRechthoek(p) {
    var best = Infinity;
    for (var i = 0; i < p.length; i++) {
      var a = p[i], b = p[(i + 1) % p.length], ex = b[0] - a[0], ey = b[1] - a[1], l = Math.hypot(ex, ey); if (!l) continue; ex /= l; ey /= l;
      var mn1 = Infinity, mx1 = -Infinity, mn2 = Infinity, mx2 = -Infinity;
      for (var k = 0; k < p.length; k++) { var u = p[k][0] * ex + p[k][1] * ey, v = -p[k][0] * ey + p[k][1] * ex; if (u < mn1) mn1 = u; if (u > mx1) mx1 = u; if (v < mn2) mn2 = v; if (v > mx2) mx2 = v; }
      best = Math.min(best, (mx1 - mn1) * (mx2 - mn2));
    }
    return best;
  }
  function vulPoly(p, w, h) {
    var m = new Uint8Array(w * h);
    for (var y = 0; y < h; y++) {
      var xs = [], yc = y + 0.5;
      for (var i = 0; i < p.length; i++) { var a = p[i], b = p[(i + 1) % p.length]; if ((a[1] <= yc && b[1] > yc) || (b[1] <= yc && a[1] > yc)) xs.push(a[0] + (yc - a[1]) / (b[1] - a[1]) * (b[0] - a[0])); }
      if (xs.length < 2) continue; xs.sort(function (q, r) { return q - r; });
      for (var x = Math.max(0, Math.ceil(xs[0] - 0.5)); x <= Math.min(w - 1, Math.floor(xs[xs.length - 1] + 0.5)); x++) m[y * w + x] = 1;
    }
    return m;
  }

  function analyseer(img) {
    var s = Math.min(1, LAAG / Math.max(img.naturalWidth || img.width, img.naturalHeight || img.height));
    var w = Math.max(1, Math.round((img.naturalWidth || img.width) * s)), h = Math.max(1, Math.round((img.naturalHeight || img.height) * s)), n = w * h;
    var c = document.createElement('canvas'); c.width = w; c.height = h; var cx = c.getContext('2d'); cx.drawImage(img, 0, 0, w, h);
    var d = cx.getImageData(0, 0, w, h).data, L = new Float32Array(n), A = new Float32Array(n), B = new Float32Array(n), doorzichtig = 0;
    for (var i = 0; i < n; i++) { var lab = rgbNaarLab(d[i * 4], d[i * 4 + 1], d[i * 4 + 2]); L[i] = lab[0]; A[i] = lab[1]; B[i] = lab[2]; if (d[i * 4 + 3] < 20) doorzichtig++; }
    if (doorzichtig / n > 0.05) {
      var vol = new Uint8Array(n); for (var t = 0; t < n; t++) vol[t] = d[t * 4 + 3] > 40 ? 1 : 0;
      return { w: w, h: h, s: s, stukken: stukkenUit(vol, w, h, null, n), achter: null, transparant: true };
    }
    var glad = new Uint8Array(n);
    for (var y = 1; y < h - 1; y++) for (var x = 1; x < w - 1; x++) {
      var p = y * w + x, sm = 0, sq = 0;
      for (var dy = -1; dy <= 1; dy++) for (var dx = -1; dx <= 1; dx++) { var v = L[p + dy * w + dx]; sm += v; sq += v * v; }
      var mu = sm / 9; glad[p] = Math.sqrt(Math.max(0, sq / 9 - mu * mu)) < 2.5 ? 1 : 0;
    }
    for (var e = 0; e < w; e++) { glad[e] = glad[w + e]; glad[(h - 1) * w + e] = glad[(h - 2) * w + e]; }
    for (var e2 = 0; e2 < h; e2++) { glad[e2 * w] = glad[e2 * w + 1]; glad[e2 * w + w - 1] = glad[e2 * w + w - 2]; }
    var reg = new Int32Array(n), wacht = new Int32Array(n), regs = [null], T2 = 36;
    for (var s0 = 0; s0 < n; s0++) {
      if (!glad[s0] || reg[s0]) continue;
      var rid = regs.length, kop = 0, staart = 0, sL = L[s0], sA = A[s0], sB = B[s0], cnt = 1, rand = 0;
      wacht[staart++] = s0; reg[s0] = rid;
      while (kop < staart) {
        var q = wacht[kop++], qx = q % w, qy = (q - qx) / w, mL = sL / cnt, mA = sA / cnt, mB = sB / cnt;
        if (qx === 0 || qy === 0 || qx === w - 1 || qy === h - 1) rand++;
        var bur = [qx > 0 ? q - 1 : -1, qx < w - 1 ? q + 1 : -1, qy > 0 ? q - w : -1, qy < h - 1 ? q + w : -1];
        for (var k = 0; k < 4; k++) {
          var r2 = bur[k]; if (r2 < 0 || reg[r2] || !glad[r2]) continue;
          var a1 = L[r2] - mL, a2 = A[r2] - mA, a3 = B[r2] - mB;
          if (a1 * a1 * 0.5 + a2 * a2 + a3 * a3 < T2) { reg[r2] = rid; wacht[staart++] = r2; sL += L[r2]; sA += A[r2]; sB += B[r2]; cnt++; }
        }
      }
      regs.push({ id: rid, opp: cnt, rand: rand, m: [sL / cnt, sA / cnt, sB / cnt] });
    }
    var omtrek = 2 * (w + h), groot = regs.filter(function (r) { return r && r.opp > 0.04 * n; });
    var kaart = null;
    groot.forEach(function (r) {
      if (r.rand > 0.03 * omtrek) return;
      var pts = [];
      for (var yy = 0; yy < h; yy++) { var lo = -1, hi = -1; for (var xx = 0; xx < w; xx++) if (reg[yy * w + xx] === r.id) { if (lo < 0) lo = xx; hi = xx; } if (lo >= 0) { pts.push([lo, yy]); pts.push([hi + 1, yy]); pts.push([lo, yy + 1]); pts.push([hi + 1, yy + 1]); } }
      var hul = omhulsel(pts), ho = polyOpp(hul), recht = ho / kleinsteRechthoek(hul), vul = r.opp / ho;
      if (recht > 0.88 && vul > 0.35 && (!kaart || ho > kaart.ho)) kaart = { r: r, hul: hul, ho: ho };
    });
    var bak, gebied, achter;
    if (kaart) {
      achter = kaart.r.m; gebied = erodeer(vulPoly(kaart.hul, w, h), w, h, 2);
      bak = new Uint8Array(n); for (var b1 = 0; b1 < n; b1++) bak[b1] = (reg[b1] === kaart.r.id || (glad[b1] && afstand(L, A, B, b1, achter) < 7)) ? 1 : 0;
    } else {
      var randR = groot.filter(function (r) { return r.rand > 0.15 * omtrek; });
      var dekking = randR.reduce(function (t2, r) { return t2 + r.rand; }, 0);
      if (!randR.length || dekking < 0.75 * omtrek) return null;
      var ids = {}; randR.forEach(function (r) { ids[r.id] = 1; });
      var som = [0, 0, 0], tel = 0; randR.forEach(function (r) { som[0] += r.m[0] * r.opp; som[1] += r.m[1] * r.opp; som[2] += r.m[2] * r.opp; tel += r.opp; });
      achter = [som[0] / tel, som[1] / tel, som[2] / tel];
      gebied = new Uint8Array(n).fill(1);
      bak = new Uint8Array(n);
      for (var b2 = 0; b2 < n; b2++) {
        if (ids[reg[b2]]) { bak[b2] = 1; continue; }
        if (!glad[b2]) continue;
        for (var z = 0; z < randR.length; z++) if (afstand(L, A, B, b2, randR[z].m) < 7) { bak[b2] = 1; break; }
      }
    }
    var gat = new Uint8Array(n); for (var g = 0; g < n; g++) gat[g] = gebied[g] && !bak[g] ? 1 : 0;
    var stukken = stukkenUit(gat, w, h, kaart ? null : true, kaart ? kaart.ho : n, L, A, B);
    if (!kaart) {
      var tot = stukken.reduce(function (t3, q) { return t3 + q.opp; }, 0);
      if (tot > 0.6 * n) return null;
    }
    return { w: w, h: h, s: s, stukken: stukken, achter: achter, transparant: false };
  }

  function stukkenUit(gat, w, h, randFilter, basisOpp, L, A, B) {
    var n = w * h, open = dilateer(erodeer(gat, w, h, 2), w, h, 2);
    for (var i = 0; i < n; i++) open[i] = open[i] && gat[i] ? 1 : 0;
    var r0 = labels(open, w, h), uit = new Int32Array(n), volg = 1;
    r0.info.forEach(function (q) {
      if (!q || q.opp < 0.008 * basisOpp) return;
      var cw = q.x1 - q.x0 + 1, ch = q.y1 - q.y0 + 1, m = new Uint8Array(cw * ch);
      for (var y = 0; y < ch; y++) for (var x = 0; x < cw; x++) if (r0.lab[(q.y0 + y) * w + q.x0 + x] === q.id) m[y * cw + x] = 1;
      var dk = afstandKaart(m, cw, ch), mx = 0; for (var t = 0; t < dk.length; t++) if (dk[t] > mx) mx = dk[t];
      var delen = null;
      for (var rr = 1; rr <= mx * 0.5 && !delen; rr++) {
        var er = new Uint8Array(cw * ch); for (var u = 0; u < er.length; u++) er[u] = dk[u] > rr ? 1 : 0;
        var l2 = labels(er, cw, ch), groot = [];
        l2.info.forEach(function (z) { if (!z || z.opp <= 0.12 * q.opp) return; var zm = 0; for (var v = 0; v < l2.lab.length; v++) if (l2.lab[v] === z.id && dk[v] > zm) zm = dk[v]; if (rr <= 0.5 * zm) groot.push(z.id); });
        if (groot.length >= 2) {
          var zaad = new Int32Array(cw * ch), rij = new Int32Array(cw * ch), kop = 0, st = 0;
          groot.forEach(function (gid, j) { for (var v = 0; v < zaad.length; v++) if (l2.lab[v] === gid) { zaad[v] = j + 1; rij[st++] = v; } });
          while (kop < st) {
            var p = rij[kop++], px = p % cw, py = (p - px) / cw;
            [px > 0 ? p - 1 : -1, px < cw - 1 ? p + 1 : -1, py > 0 ? p - cw : -1, py < ch - 1 ? p + cw : -1].forEach(function (b) { if (b >= 0 && m[b] && !zaad[b]) { zaad[b] = zaad[p]; rij[st++] = b; } });
          }
          delen = { zaad: zaad, aantal: groot.length };
        }
      }
      var aantal = delen ? delen.aantal : 1;
      for (var k = 0; k < aantal; k++) {
        var id = volg++;
        for (var y2 = 0; y2 < ch; y2++) for (var x2 = 0; x2 < cw; x2++) { var mi = y2 * cw + x2; if (m[mi] && (!delen || delen.zaad[mi] === k + 1)) uit[(q.y0 + y2) * w + q.x0 + x2] = id; }
      }
    });
    var res = [];
    for (var id2 = 1; id2 < volg; id2++) {
      var x0 = w, y0 = h, x1 = -1, y1 = -1;
      for (var p2 = 0; p2 < n; p2++) if (uit[p2] === id2) { var xx = p2 % w, yy = (p2 - xx) / w; if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (yy < y0) y0 = yy; if (yy > y1) y1 = yy; }
      if (x1 < 0) continue;
      var bw = x1 - x0 + 3, bh = y1 - y0 + 3, buiten = new Uint8Array(bw * bh), stap = [0], kk = 0; buiten[0] = 1;
      var binnen = function (xb, yb) { var gx = x0 - 1 + xb, gy = y0 - 1 + yb; return gx >= 0 && gy >= 0 && gx < w && gy < h && uit[gy * w + gx] === id2; };
      while (kk < stap.length) {
        var pb = stap[kk++], xb = pb % bw, yb = (pb - xb) / bw;
        [[xb - 1, yb], [xb + 1, yb], [xb, yb - 1], [xb, yb + 1]].forEach(function (c2) { if (c2[0] < 0 || c2[1] < 0 || c2[0] >= bw || c2[1] >= bh) return; var ib = c2[1] * bw + c2[0]; if (buiten[ib] || binnen(c2[0], c2[1])) return; buiten[ib] = 1; stap.push(ib); });
      }
      var opp = 0, rand = 0, sL = 0, sA = 0, sB = 0;
      for (var yb2 = 1; yb2 < bh - 1; yb2++) for (var xb2 = 1; xb2 < bw - 1; xb2++) {
        if (buiten[yb2 * bw + xb2]) continue;
        var gp = (y0 - 1 + yb2) * w + (x0 - 1 + xb2); uit[gp] = id2; opp++;
        var gx2 = gp % w, gy2 = (gp - gx2) / w; if (gx2 === 0 || gy2 === 0 || gx2 === w - 1 || gy2 === h - 1) rand++;
        if (L) { sL += L[gp]; sA += A[gp]; sB += B[gp]; }
      }
      var info2 = { id: id2, x0: x0, y0: y0, x1: x1, y1: y1, opp: opp, rand: rand, m: L ? [sL / opp, sA / opp, sB / opp] : null };
      var bwid = x1 - x0 + 1, bhoog = y1 - y0 + 1, vulling = opp / (bwid * bhoog), asp = bwid / bhoog;
      if (opp < 0.01 * basisOpp || bwid < 8 || bhoog < 8 || vulling < 0.18) continue;
      if (info2.m && info2.m[0] > 72 && Math.abs(info2.m[1]) < 6 && Math.abs(info2.m[2]) < 8 && vulling > 0.7 && vulling < 0.87 && asp > 0.85 && asp < 1.18) continue;
      if (randFilter && rand > 0.04 * (2 * (bwid + bhoog))) continue;
      if ((asp > 2.8 || asp < 0.36) && vulling < 0.6) continue;
      res.push(info2);
    }
    res.masker = uit;
    return res;
  }

  function snij(img, an, stuk) {
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height, w = an.w, h = an.h, uit = an.stukken.masker;
    var pad = 3, lx0 = Math.max(0, stuk.x0 - pad), ly0 = Math.max(0, stuk.y0 - pad), lx1 = Math.min(w - 1, stuk.x1 + pad), ly1 = Math.min(h - 1, stuk.y1 + pad);
    var lw = lx1 - lx0 + 1, lh = ly1 - ly0 + 1, m = new Uint8Array(lw * lh);
    for (var y = 0; y < lh; y++) for (var x = 0; x < lw; x++) m[y * lw + x] = uit[(ly0 + y) * w + lx0 + x] === stuk.id ? 1 : 0;
    var zeker = erodeer(m, lw, lh, 1.5), mogelijk = dilateer(m, lw, lh, 2);
    var sx = iw / w, sy = ih / h;
    var hx0 = Math.floor(lx0 * sx), hy0 = Math.floor(ly0 * sy), hw0 = Math.ceil(lw * sx), hh0 = Math.ceil(lh * sy);
    hw0 = Math.min(hw0, iw - hx0); hh0 = Math.min(hh0, ih - hy0);
    var k = Math.min(1, MAXSTUK / Math.max(hw0, hh0), HOOG / Math.max(iw, ih)), cw = Math.max(1, Math.round(hw0 * k)), ch = Math.max(1, Math.round(hh0 * k));
    var c = document.createElement('canvas'); c.width = cw; c.height = ch; var cx = c.getContext('2d');
    cx.drawImage(img, hx0, hy0, hw0, hh0, 0, 0, cw, ch);
    var data = cx.getImageData(0, 0, cw, ch), d = data.data, ach = an.achter;
    function monster(arr, fx, fy) {
      var x0 = Math.max(0, Math.min(lw - 1, Math.floor(fx))), y0 = Math.max(0, Math.min(lh - 1, Math.floor(fy))), x1 = Math.min(lw - 1, x0 + 1), y1 = Math.min(lh - 1, y0 + 1), tx = Math.max(0, Math.min(1, fx - x0)), ty = Math.max(0, Math.min(1, fy - y0));
      return (arr[y0 * lw + x0] * (1 - tx) + arr[y0 * lw + x1] * tx) * (1 - ty) + (arr[y1 * lw + x0] * (1 - tx) + arr[y1 * lw + x1] * tx) * ty;
    }
    for (var py = 0; py < ch; py++) for (var px = 0; px < cw; px++) {
      var fx = px / cw * lw - 0.5, fy = py / ch * lh - 0.5, i = (py * cw + px) * 4;
      if (an.transparant) { var mt = monster(m, fx, fy); d[i + 3] = Math.round(d[i + 3] * Math.min(1, mt * 1.5)); continue; }
      var nx = Math.max(0, Math.min(lw - 1, Math.round(fx))), ny = Math.max(0, Math.min(lh - 1, Math.round(fy))), ander = uit[(ly0 + ny) * w + lx0 + nx];
      if (ander && ander !== stuk.id) { d[i + 3] = 0; continue; }
      var zk = monster(zeker, fx, fy), mg = monster(mogelijk, fx, fy), a;
      if (zk > 0.5) a = 1; else if (mg < 0.5) a = 0;
      else {
        var lab = rgbNaarLab(d[i], d[i + 1], d[i + 2]), dl = lab[0] - ach[0], da = lab[1] - ach[1], db = lab[2] - ach[2];
        var dist = Math.sqrt(dl * dl * 0.5 + da * da + db * db);
        a = Math.max(0, Math.min(1, (dist - 5) / 9)) * Math.min(1, monster(m, fx, fy) * 1.6 + 0.2);
      }
      d[i + 3] = Math.round(d[i + 3] * a);
    }
    cx.putImageData(data, 0, 0);
    return c;
  }

  function knip(img) {
    var an = analyseer(img);
    if (!an || !an.stukken.length) return [];
    var grootste = an.stukken.reduce(function (m, q) { return Math.max(m, q.opp); }, 0);
    var lijst = an.stukken.filter(function (q) { var asp = (q.x1 - q.x0 + 1) / (q.y1 - q.y0 + 1); if (q.opp < 0.22 * grootste) return false; if ((asp > 2.5 || asp < 0.4) && q.opp < 0.6 * grootste) return false; return true; });
    lijst.sort(function (a, b) { var r = a.opp / b.opp; return (r > 1.6 || r < 0.625) ? b.opp - a.opp : (Math.abs(a.y0 - b.y0) > an.h * 0.12 ? a.y0 - b.y0 : a.x0 - b.x0); });
    return lijst.slice(0, 12).map(function (s) { return snij(img, an, s); });
  }
  return { knip: knip, analyseer: analyseer };
})();

(function () {
  var root = document.querySelector('[data-hz-passen]');
  if (!root || root.dataset.klaar) return;
  root.dataset.klaar = '1';
  var bronnen = {};
  try { bronnen = JSON.parse(root.querySelector('[data-hz-bronnen]').textContent); } catch (e) { return; }

  function $(s) { return root.querySelector(s); }
  var dlg = $('.hz-pd'), podium = $('[data-hz-podium]'), video = $('.hz-pd__video'), foto = $('.hz-pd__foto');
  var sjabloon = $('[data-hz-sjabloon]'), snel = $('.hz-pd__snel'), melding = $('[data-hz-melding]'), tip = $('[data-hz-tip]');
  var grootte = $('[data-hz-grootte]'), draai = $('[data-hz-draai]'), bediening = $('[data-hz-bediening]');
  var keuze = $('[data-hz-keuze]'), stukjesEl = $('[data-hz-stukjes]'), wegKnop = $('[data-hz-stap="weg"]');
  var resultaat = $('[data-hz-resultaat]'), resImg = $('[data-hz-resultaat-img]'), bewaar = $('[data-hz-bewaar]'), deel = $('[data-hz-deel]');

  var stukken = [];
  var geplaatst = [];
  var actief = 0, stream = null, facing = 'user', bron = 'camera';
  var woord = root.dataset.woord || 'speldje';
  var beginStand = (root.dataset.start || '0.5,0.28,1').split(',').map(Number);
  function beginSt() { return { x: beginStand[0], y: beginStand[1], s: beginStand[2], r: 0 }; }

  function laad(src) {
    return new Promise(function (ok, nee) { var i = new Image(); i.crossOrigin = 'anonymous'; i.onload = function () { ok(i); }; i.onerror = nee; i.src = src; });
  }
  function canvasVan(img) {
    var c = document.createElement('canvas'); c.width = img.naturalWidth; c.height = img.naturalHeight;
    c.getContext('2d').drawImage(img, 0, 0); return c;
  }
  function heeftTransparantie(c) {
    var d = c.getContext('2d').getImageData(0, 0, c.width, c.height).data, leeg = 0, n = 0;
    for (var k = 3; k < d.length; k += 4 * 7) { n++; if (d[k] < 20) leeg++; }
    return leeg / n > 0.05;
  }
  function splits(c) {
    var w = c.width, h = c.height, src = c.getContext('2d').getImageData(0, 0, w, h), d = src.data, n = w * h;
    var vol = new Uint8Array(n), totaal = 0;
    for (var i = 0; i < n; i++) if (d[i * 4 + 3] > 40) { vol[i] = 1; totaal++; }
    if (!totaal) return [];
    var r = Math.max(2, Math.round(Math.min(w, h) / 160)), dik = new Uint8Array(n), rij = new Uint8Array(n);
    for (var y = 0; y < h; y++) { var acc = 0; for (var x = -r; x < w; x++) { if (x + r < w && vol[y * w + x + r]) acc++; if (x - r - 1 >= 0 && vol[y * w + x - r - 1]) acc--; if (x >= 0) rij[y * w + x] = acc > 0 ? 1 : 0; } }
    for (var x2 = 0; x2 < w; x2++) { var acc2 = 0; for (var y2 = -r; y2 < h; y2++) { if (y2 + r < h && rij[(y2 + r) * w + x2]) acc2++; if (y2 - r - 1 >= 0 && rij[(y2 - r - 1) * w + x2]) acc2--; if (y2 >= 0) dik[y2 * w + x2] = acc2 > 0 ? 1 : 0; } }
    var label = new Int32Array(n), delen = [], stapel = new Int32Array(n);
    for (var s = 0; s < n; s++) {
      if (!dik[s] || label[s]) continue;
      var id = delen.length + 1, top = 0, x0 = w, y0 = h, x1 = 0, y1 = 0, opp = 0;
      stapel[top++] = s; label[s] = id;
      while (top) {
        var p = stapel[--top], px = p % w, py = (p - px) / w;
        if (vol[p]) opp++;
        if (px < x0) x0 = px; if (px > x1) x1 = px; if (py < y0) y0 = py; if (py > y1) y1 = py;
        if (px > 0 && dik[p - 1] && !label[p - 1]) { label[p - 1] = id; stapel[top++] = p - 1; }
        if (px < w - 1 && dik[p + 1] && !label[p + 1]) { label[p + 1] = id; stapel[top++] = p + 1; }
        if (py > 0 && dik[p - w] && !label[p - w]) { label[p - w] = id; stapel[top++] = p - w; }
        if (py < h - 1 && dik[p + w] && !label[p + w]) { label[p + w] = id; stapel[top++] = p + w; }
      }
      delen.push({ id: id, x0: x0, y0: y0, x1: x1, y1: y1, opp: opp });
    }
    delen = delen.filter(function (q) { return q.opp > totaal * 0.03 && (q.x1 - q.x0) > 10 && (q.y1 - q.y0) > 10; });
    delen.sort(function (a, b) { return Math.abs(a.y0 - b.y0) > h * 0.15 ? a.y0 - b.y0 : a.x0 - b.x0; });
    return delen.map(function (q) {
      var cw = q.x1 - q.x0 + 1, ch = q.y1 - q.y0 + 1, o = document.createElement('canvas'); o.width = cw; o.height = ch;
      var ox = o.getContext('2d'), od = ox.createImageData(cw, ch);
      for (var yy = 0; yy < ch; yy++) for (var xx = 0; xx < cw; xx++) {
        var sp = (q.y0 + yy) * w + (q.x0 + xx);
        if (label[sp] !== q.id) continue;
        var a = sp * 4, b = (yy * cw + xx) * 4;
        od.data[b] = d[a]; od.data[b + 1] = d[a + 1]; od.data[b + 2] = d[a + 2]; od.data[b + 3] = d[a + 3];
      }
      ox.putImageData(od, 0, 0); return o;
    });
  }
  function naarStuk(c) {
    return new Promise(function (ok) { c.toBlob(function (b) { ok({ url: URL.createObjectURL(b), w: c.width, h: c.height }); }, 'image/png'); });
  }
  function verzamel() {
    var lijst = bronnen.cutouts || [], doekjes = [];
    var reeks = lijst.reduce(function (p, src) {
      return p.then(function () { return laad(src).then(function (i) {
        var c = canvasVan(i);
        if (heeftTransparantie(c)) doekjes = doekjes.concat(splits(c));
        else doekjes = doekjes.concat(HZKnip.knip(i));
      }, function () {}); });
    }, Promise.resolve());
    return reeks.then(function () {
      if (doekjes.length) return doekjes;
      var fotos = (bronnen.fotos || []).slice();
      function volgende() {
        if (!fotos.length) return [];
        return laad(fotos.shift()).then(function (i) {
          var s = []; try { s = HZKnip.knip(i); } catch (e) {}
          return s.length ? s : volgende();
        }, volgende);
      }
      return volgende();
    }).then(function (cs) { return Promise.all(cs.slice(0, 12).map(naarStuk)); });
  }

  function teken(g) {
    var r = podium.getBoundingClientRect(), stuk = stukken[g.stuk];
    var bw = r.width * 0.4 * g.st.s, bh = bw * stuk.h / stuk.w;
    g.el.style.width = bw + 'px';
    g.el.style.transform = 'translate(' + (g.st.x * r.width - bw / 2) + 'px,' + (g.st.y * r.height - bh / 2) + 'px) rotate(' + g.st.r + 'deg)';
  }
  function tekenAlles() { geplaatst.forEach(teken); }
  function huidig() { return geplaatst[actief]; }
  function werkBij() {
    geplaatst.forEach(function (g, i) { g.el.classList.toggle('is-actief', i === actief); });
    var g = huidig(); if (!g) return;
    grootte.value = Math.round(g.st.s * 100); draai.value = Math.round(g.st.r);
    Array.prototype.forEach.call(stukjesEl.children, function (b, i) { b.setAttribute('aria-pressed', String(i === g.stuk)); });
    wegKnop.hidden = geplaatst.length < 2;
    tekenAlles();
  }
  function plaats(stukIndex, st) {
    var el = sjabloon.content.firstElementChild.cloneNode(true), img = el.querySelector('.hz-pd__clip');
    img.src = stukken[stukIndex].url; podium.insertBefore(el, snel);
    var g = { stuk: stukIndex, st: st, el: el, img: img };
    el.addEventListener('focus', function () { actief = geplaatst.indexOf(g); werkBij(); });
    el.addEventListener('keydown', toets);
    geplaatst.push(g); actief = geplaatst.length - 1; werkBij();
  }
  function wisAlles() { geplaatst.forEach(function (g) { g.el.remove(); }); geplaatst = []; actief = 0; }

  function maakKeuze() {
    stukjesEl.innerHTML = '';
    stukken.forEach(function (s, i) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'hz-pd__stukje';
      b.setAttribute('aria-label', woord.charAt(0).toUpperCase() + woord.slice(1) + ' ' + (i + 1) + ' van ' + stukken.length); b.setAttribute('aria-pressed', 'false');
      var im = document.createElement('img'); im.src = s.url; im.alt = ''; b.appendChild(im);
      b.addEventListener('click', function () { var g = huidig(); if (!g) return; g.stuk = i; g.img.src = s.url; werkBij(); });
      stukjesEl.appendChild(b);
    });
    keuze.hidden = false;
  }

  function toonMelding(t) { melding.textContent = t; melding.hidden = !t; }
  function stopCamera() { if (stream) { stream.getTracks().forEach(function (t) { t.stop(); }); stream = null; } }
  function startCamera() {
    stopCamera(); toonMelding('');
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) { toonMelding('Je camera is hier niet beschikbaar. Kies een foto om te passen.'); return; }
    navigator.mediaDevices.getUserMedia({ video: { facingMode: facing }, audio: false }).then(function (s) {
      stream = s; bron = 'camera'; foto.hidden = true; video.hidden = false;
      video.srcObject = s; video.classList.toggle('is-spiegel', facing === 'user'); video.play();
    }).catch(function () { toonMelding('Geen toegang tot je camera. Geef toestemming in je browser, of kies een foto.'); });
  }

  $('[data-hz-open]').addEventListener('click', function () {
    resultaat.hidden = true; bediening.hidden = false; podium.hidden = false; tip.hidden = false;
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    wisAlles(); plaats(0, beginSt());
    requestAnimationFrame(tekenAlles);
    startCamera();
  });
  $('[data-hz-sluit]').addEventListener('click', function () { stopCamera(); if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); });
  dlg.addEventListener('close', stopCamera);
  $('[data-hz-wissel]').addEventListener('click', function () { facing = facing === 'user' ? 'environment' : 'user'; startCamera(); });
  $('[data-hz-bestand]').addEventListener('change', function (e) {
    var f = e.target.files && e.target.files[0]; if (!f) return;
    stopCamera(); toonMelding(''); bron = 'foto'; foto.src = URL.createObjectURL(f); foto.hidden = false; video.hidden = true;
  });
  $('[data-hz-erbij]').addEventListener('click', function () {
    var g = huidig(), basis = g ? g.st : beginSt();
    var nx = 1 - basis.x; if (Math.abs(nx - basis.x) < 0.15) nx = basis.x + 0.2;
    plaats(g ? (g.stuk + 1) % stukken.length : 0, { x: Math.min(0.9, Math.max(0.1, nx)), y: basis.y, s: basis.s, r: -basis.r });
    tip.hidden = true;
  });
  grootte.addEventListener('input', function () { var g = huidig(); if (g) { g.st.s = grootte.value / 100; teken(g); } });
  draai.addEventListener('input', function () { var g = huidig(); if (g) { g.st.r = +draai.value; teken(g); } });
  window.addEventListener('resize', function () { if (dlg.open) tekenAlles(); });

  function normaal(r) { while (r > 180) r -= 360; while (r < -180) r += 360; return r; }
  function stap(soort) {
    var g = huidig(); if (!g) return;
    if (soort === 'weg') { if (geplaatst.length > 1) { g.el.remove(); geplaatst.splice(actief, 1); actief = Math.max(0, actief - 1); } werkBij(); return; }
    if (soort === 's-') g.st.s = Math.max(0.2, g.st.s / 1.12);
    if (soort === 's+') g.st.s = Math.min(2.5, g.st.s * 1.12);
    if (soort === 'r-') g.st.r = normaal(g.st.r - 10);
    if (soort === 'r+') g.st.r = normaal(g.st.r + 10);
    werkBij();
  }
  root.querySelectorAll('[data-hz-stap]').forEach(function (b) { b.addEventListener('click', function () { stap(b.getAttribute('data-hz-stap')); tip.hidden = true; }); });
  podium.addEventListener('wheel', function (e) {
    var g = huidig(); if (!g) return; e.preventDefault();
    if (e.shiftKey) g.st.r = normaal(g.st.r + (e.deltaY > 0 ? 5 : -5));
    else g.st.s = Math.min(2.5, Math.max(0.2, g.st.s * (e.deltaY > 0 ? 0.94 : 1.06)));
    werkBij();
  }, { passive: false });
  function toets(e) {
    var g = huidig(); if (!g) return;
    var k = e.key, d = e.shiftKey ? 0.05 : 0.01, ok = true;
    if (k === 'ArrowLeft') g.st.x = Math.max(0, g.st.x - d);
    else if (k === 'ArrowRight') g.st.x = Math.min(1, g.st.x + d);
    else if (k === 'ArrowUp') g.st.y = Math.max(0, g.st.y - d);
    else if (k === 'ArrowDown') g.st.y = Math.min(1, g.st.y + d);
    else if (k === '+' || k === '=') stap('s+');
    else if (k === '-') stap('s-');
    else if (k === '[') stap('r-');
    else if (k === ']') stap('r+');
    else if (k === 'Delete' || k === 'Backspace') stap('weg');
    else ok = false;
    if (ok) { e.preventDefault(); teken(g); }
  }

  var wijzers = new Map(), start = null, greep = null;
  function momentopname() {
    var p = Array.from(wijzers.values()), g = huidig();
    if (p.length === 1) return { n: 1, x: p[0].x, y: p[0].y, st: Object.assign({}, g.st) };
    var dx = p[1].x - p[0].x, dy = p[1].y - p[0].y;
    return { n: 2, x: (p[0].x + p[1].x) / 2, y: (p[0].y + p[1].y) / 2, a: Math.atan2(dy, dx), d: Math.hypot(dx, dy), st: Object.assign({}, g.st) };
  }
  podium.addEventListener('pointerdown', function (e) {
    if (e.target.closest('.hz-pd__snel') || !geplaatst.length) return;
    tip.hidden = true;
    var kaderEl = e.target.closest('.hz-pd__kader');
    if (kaderEl && wijzers.size === 0) {
      var idx = geplaatst.findIndex(function (g) { return g.el === kaderEl; });
      if (idx > -1 && idx !== actief) { actief = idx; werkBij(); }
    }
    if (e.target.closest('[data-hz-greep]')) {
      var g = huidig(), kr = g.el.getBoundingClientRect(), cx = kr.left + kr.width / 2, cy = kr.top + kr.height / 2;
      greep = { id: e.pointerId, cx: cx, cy: cy, a: Math.atan2(e.clientY - cy, e.clientX - cx), d: Math.hypot(e.clientX - cx, e.clientY - cy), st: Object.assign({}, g.st) };
      podium.setPointerCapture(e.pointerId); e.preventDefault(); return;
    }
    podium.setPointerCapture(e.pointerId); wijzers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    start = momentopname();
  });
  podium.addEventListener('pointermove', function (e) {
    var g = huidig(); if (!g) return;
    if (greep && e.pointerId === greep.id) {
      var a = Math.atan2(e.clientY - greep.cy, e.clientX - greep.cx), dd = Math.hypot(e.clientX - greep.cx, e.clientY - greep.cy);
      if (greep.d > 4) g.st.s = Math.min(2.5, Math.max(0.2, greep.st.s * dd / greep.d));
      g.st.r = normaal(greep.st.r + (a - greep.a) * 180 / Math.PI);
      werkBij(); return;
    }
    if (!wijzers.has(e.pointerId) || !start) return;
    wijzers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    var nu = momentopname(); if (nu.n !== start.n) { start = nu; return; }
    var r = podium.getBoundingClientRect();
    g.st.x = Math.min(1, Math.max(0, start.st.x + (nu.x - start.x) / r.width));
    g.st.y = Math.min(1, Math.max(0, start.st.y + (nu.y - start.y) / r.height));
    if (nu.n === 2 && start.d > 0) {
      g.st.s = Math.min(2.5, Math.max(0.2, start.st.s * nu.d / start.d));
      g.st.r = normaal(start.st.r + (nu.a - start.a) * 180 / Math.PI);
      grootte.value = Math.round(g.st.s * 100); draai.value = Math.round(g.st.r);
    }
    teken(g);
  });
  function los(e) { if (greep && e.pointerId === greep.id) { greep = null; return; } wijzers.delete(e.pointerId); start = wijzers.size ? momentopname() : null; }
  podium.addEventListener('pointerup', los); podium.addEventListener('pointercancel', los);

  $('[data-hz-vastleggen]').addEventListener('click', function () {
    var r = podium.getBoundingClientRect(), schaal = 2;
    var c = document.createElement('canvas'); c.width = Math.round(r.width * schaal); c.height = Math.round(r.height * schaal);
    var x = c.getContext('2d'), src = bron === 'camera' ? video : foto;
    var sw = bron === 'camera' ? video.videoWidth : foto.naturalWidth, sh = bron === 'camera' ? video.videoHeight : foto.naturalHeight;
    if (!sw || !sh) { toonMelding('Er is nog geen beeld. Zet je camera aan of kies een foto.'); return; }
    var k = Math.max(c.width / sw, c.height / sh), dw = sw * k, dh = sh * k;
    x.save(); if (bron === 'camera' && facing === 'user') { x.translate(c.width, 0); x.scale(-1, 1); }
    x.drawImage(src, (c.width - dw) / 2, (c.height - dh) / 2, dw, dh); x.restore();
    geplaatst.forEach(function (g) {
      var stuk = stukken[g.stuk], bw = r.width * 0.4 * g.st.s * schaal, bh = bw * stuk.h / stuk.w;
      x.save(); x.translate(g.st.x * c.width, g.st.y * c.height); x.rotate(g.st.r * Math.PI / 180);
      x.shadowColor = 'rgba(0,0,0,.25)'; x.shadowBlur = 8; x.shadowOffsetY = 4;
      x.drawImage(g.img, -bw / 2, -bh / 2, bw, bh); x.restore();
    });
    c.toBlob(function (b) {
      var url = URL.createObjectURL(b); resImg.src = url; bewaar.href = url;
      var bestand = new File([b], 'haarspeldjes-en-zo-passen.jpg', { type: 'image/jpeg' });
      if (navigator.canShare && navigator.canShare({ files: [bestand] })) {
        deel.hidden = false; deel.onclick = function () { navigator.share({ files: [bestand], title: bronnen.naam }).catch(function () {}); };
      }
      stopCamera(); podium.hidden = true; bediening.hidden = true; resultaat.hidden = false;
    }, 'image/jpeg', 0.9);
  });
  $('[data-hz-opnieuw]').addEventListener('click', function () {
    resultaat.hidden = true; podium.hidden = false; bediening.hidden = false;
    if (bron === 'camera') startCamera(); requestAnimationFrame(tekenAlles);
  });

  var go = function () {
    verzamel().then(function (s) {
      if (!s.length) return;
      stukken = s; if (s.length > 1) maakKeuze(); root.hidden = false;
    }).catch(function () {});
  };
  if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 2500 }); else setTimeout(go, 800);
})();
